
import React from 'react';
import { CommunicationTemplate } from '@/services/communication/templates';
import TemplateCard from './TemplateCard';
import TemplateActions from './TemplateActions';

interface TemplateListProps {
  templates: CommunicationTemplate[];
  onSelectTemplate: (template: CommunicationTemplate) => void;
  onCopyToClipboard: (template: CommunicationTemplate) => void;
  onEditTemplate: (template: CommunicationTemplate) => void;
  onDeleteTemplate: (id: string) => void;
  onSendEmail?: (template: CommunicationTemplate) => void;
}

const TemplateList: React.FC<TemplateListProps> = ({
  templates,
  onSelectTemplate,
  onCopyToClipboard,
  onEditTemplate,
  onDeleteTemplate,
  onSendEmail,
}) => {
  return (
    <div className="flex flex-col gap-4">
      {templates.map((template, index) => (
        <div 
          key={template.id} 
          className="relative group animate-in fade-in duration-300"
          style={{
            animationDelay: `${index * 50}ms`,
            animationFillMode: 'backwards'
          }}
        >
          <TemplateCard 
            template={template}
          />
          <TemplateActions
            template={template}
            onEdit={onEditTemplate}
            onCopy={onCopyToClipboard}
            onDelete={onDeleteTemplate}
            onSendEmail={onSendEmail}
          />
        </div>
      ))}
    </div>
  );
};

export default TemplateList;
